<template>
  <Dropdown :placement="isRtl ? 'bottom-end' : 'bottom-start'" dusk="select-all-dropdown">
    <Button
      variant="ghost"
      trailing-icon="chevron-down"
      padding="tight"
      class="panel-toolbar-select-trigger"
      :class="{
        'panel-toolbar-select-trigger--active':
          selectAllOrSelectAllMatchingChecked || selectedResourcesCount > 0,
      }"
      dusk="select-all-dropdown-trigger"
    >
      <Checkbox
        :aria-label="__('Select this page')"
        :indeterminate="selectAllIndeterminate"
        :model-value="selectAllAndSelectAllMatchingChecked"
        class="pointer-events-none shrink-0"
        dusk="select-all-indicator"
        tabindex="-1"
      />

      <div
        ref="selectedStatus"
        v-if="selectedResourcesCount > 0"
        class="panel-toolbar-selected-chip inline-flex shrink-0 items-center gap-1"
      >
        <span>{{
          __(':amount selected', {
            amount: selectAllMatchingChecked
              ? allMatchingResourceCount
              : selectedResourcesCount,
            label: singularOrPlural(selectedResourcesCount, 'resources'),
          })
        }}</span>
        <Button
          @click.stop="$emit('deselect')"
          variant="link"
          icon="x-circle"
          size="small"
          state="mellow"
          :aria-label="__('Deselect All')"
          dusk="deselect-all-button"
        />
      </div>
    </Button>

    <template #menu>
      <DropdownMenu
        :direction="isRtl ? 'rtl' : 'ltr'"
        width="250"
        class="panel-toolbar-menu"
      >
        <div class="panel-toolbar-menu-body">
          <Checkbox
            @change="$emit('toggle-select-all')"
            :model-value="selectAllChecked"
            dusk="select-all-button"
          >
            <span>{{ __('Select this page') }}</span>
            <CircleBadge>{{ currentPageCount }}</CircleBadge>
          </Checkbox>

          <Checkbox
            @change="$emit('toggle-select-all-matching')"
            :model-value="selectAllMatchingChecked"
            dusk="select-all-matching-button"
          >
            <span>{{ __('Select all') }}</span>
            <CircleBadge dusk="select-all-matching-count">
              {{ allMatchingResourceCount }}
            </CircleBadge>
          </Checkbox>
        </div>
      </DropdownMenu>
    </template>
  </Dropdown>
</template>

<script setup>
import { inject, computed } from 'vue'
import { singularOrPlural } from '@/util'
import { Checkbox, Button } from 'laravel-nova-ui'

defineEmits(['toggle-select-all', 'toggle-select-all-matching', 'deselect'])

const isRtl = computed(() => Nova.config('rtlEnabled'))

const selectedResourcesCount = inject('selectedResourcesCount')
const selectAllChecked = inject('selectAllChecked')
const selectAllMatchingChecked = inject('selectAllMatchingChecked')
const selectAllAndSelectAllMatchingChecked = inject(
  'selectAllAndSelectAllMatchingChecked'
)
const selectAllOrSelectAllMatchingChecked = inject(
  'selectAllOrSelectAllMatchingChecked'
)
const selectAllIndeterminate = inject('selectAllIndeterminate')

defineProps({
  currentPageCount: { type: Number, default: 0 },
  allMatchingResourceCount: { type: Number, default: 0 },
})
</script>
